<template>
  <v-card flat class="px-5">
    <ValidationObserver ref="observer">
      <template v-for="field in fields" >

        <div :key="field.title" class="text-subtitle-1 text-button my-3">
          {{ field.title }}
        </div>
        <v-row dense>
          <v-col cols="4" v-for="detail in field.details" :key="detail.name">
            <ValidationProvider
              :name="detail.label"
              :rules="detail.rules"
              events="['blur']"
              v-slot="{ errors }"
            >
              
              <BranchPicker
                v-if="detail.type == 'branch'"
                dense
                :label="detail.label + detail.rules.includes('required') ? '*':''"
                :error-messages="errors"
                v-model="details[detail.value]"
              ></BranchPicker>

              <v-select
                v-else-if="detail.type ==='select'"
                :label="detail.label + detail.rules.includes('required') ? '*':''"
                v-model="details[detail.value]"
                outlined
                dense
                :items="detail.items"
                :error-messages="errors"
              />
              <v-text-field
                v-else-if="detail.type ==='date'"
                :label="detail.label + detail.rules.includes('required') ? '*':''"
                type="date"
                v-model="details[detail.value]"
                outlined
                dense
                :error-messages="errors"
              />
              <vuetify-money
                v-else-if="detail.type ==='money'"
                type="number"
                outlined
                dense
                required
                :label="detail.label"
                v-model="details[detail.value]"
                :error-messages="errors"
                :options="VuetifyMoneyOptions"
              />
              <v-text-field
                v-else
                :label="detail.label + detail.rules.includes('required') ? '*':''"
                v-model="details[detail.value]"
                outlined
                dense
                :error-messages="errors"
              />
            </ValidationProvider>
          </v-col>

        </v-row>
      </template>
    </ValidationObserver>
  </v-card>
</template>

<script>
import { VuetifyMoneyOptions } from '@/lib/constants/options';
import BranchPicker from '@/modules/shared/components/pickers/BranchPicker.vue';

export default {
  components: { BranchPicker },
  data() {
    return {
      VuetifyMoneyOptions,
      details: {},
      fields: [  // Loan Details
        {
          title: '',
          details: [
            {
              type: 'branch',
              label: "Branch Name",
              value: "branchName",
              rules: ""
            },
            {
              label: "Loan Product",
              value: "loanProductName",
              rules: ""
            },
            {
              label: "Loan Type ",
              value: "loanProductType",
              rules: ""
            },
            {
              label: "Collateral Type",
              value: "collateralType",
              rules: ""
            },
            {
              label: "Loan Ref No.",
              value: "coreId",
              rules: "required"
            },
            {
              type: 'select',
              items: ['Disbursed', 'Closed'],
              label: "Loan Progress",
              value: "loanProgress",
              rules: "required"
            },
            {
              type: 'money',
              label: "Current Balance",
              value: "currentBalance",
              rules: ""
            },
            {
              type: 'money',
              label: "Loan Amount",
              value: "loanAmount",
              rules: ""
            },
            {
              label: "Term",
              value: "tenure",
              rules: "numeric"
            },
            {
              label: "Interest Rate",
              value: "interest",
              rules: "numeric"
            },
            {
              type: 'money',
              label: "Interest Accrued",
              value: "interestAccrued",
              rules: ""
            },
            {
              type: 'date',
              label: "Maturity Date ",
              value: "maturityDate",
              rules: "date"
            },
            {
              type: 'date',
              label: "Origination Date ",
              value: "originationDate",
              rules: "date"
            },
            {
              type: 'money',
              label: "Monthly Payment ",
              value: "monthlyPayment",
              rules: ""
            },
            {
              label: "Past Due Days",
              value: "pastDueDays",
              rules: "numeric"
            },
            {
              label: "Credit Score",
              value: "currentCreditScore",
              rules: "numeric"
            },
            {
              label: "DSR",
              value: "dsrRatio",
              rules: "numeric"
            },
            {
              label: "Networth Ratio",
              value: "networthRatio",
              rules: "numeric"
            },
            {
              label: "Loan Purpose",
              value: "loanPurpose",
              rules: "numeric"
            },
            {
              label: "Payment Method",
              value: "paymentMethod",
              rules: ""
            }
          ]
        },
        // Collateral Details
        {
          title: 'Collateral Details',
          details: [
            {
              label: "Cash Collateral",
              value: "totalCashCollateral",
              rules: "numeric"
            },
            {
              label: "Real Estate Collateral",
              value: "totalRealEstateCollateral",
              rules: "numeric"
            },
            {
              label: "Motor Vehicle Collateral",
              value: "totalMotorVehicleCollateral",
              rules: "numeric"
            },
            {
              label: "Credit Officer",
              value: "creditOfficer",
              rules: "numeric"
            }
          ]
        }
      ]
    }
  },
  
  methods: {
    clear() {
      this.details = {}
    },

    async validate() {
      return this.$refs.observer.validate();
    },

    submit() {
      this.$emit('submit', this.details)
    }
  }
}

</script>